
(function(){


const hero =
document.querySelector(
'.ms-tech-hero-v2'
);


if(!hero) return;

const video =
hero.querySelector('video');

if(video){

video.play()
.catch(()=>{});
}

})();


(function(){

let nav=document.getElementById("dealerNav");

if(!nav){
console.log("Dealer nav not found");
return;
}


let lastScrollTop=0;


window.addEventListener("scroll",function(){

let scrollTop=window.pageYOffset || document.documentElement.scrollTop;


console.log(scrollTop);


if(scrollTop > 200){


    if(scrollTop > lastScrollTop){

        // downward
        nav.classList.add("active");

    }else{

        // upward
        nav.classList.remove("active");

    }


}else{

    nav.classList.remove("active");

}


lastScrollTop=scrollTop;


});


})();